// removed by extract-text-webpack-plugin
module.exports = {"BuildControls":"BuildControls__BuildControls__DgQ4B","Price":"BuildControls__Price__3xMhe","OrderButton":"BuildControls__OrderButton__BSgWr","enable":"BuildControls__enable__18De4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BuildControls/BuildControls.css
// module id = 122
// module chunks = 3